// @flow

import type { Action } from 'app/common/redux/types';

type ConversationId = string;
export type State = {
  chatheads: ConversationId[],
  open: ?(ConversationId | 'feedback'),
  feedback: ?{ userId: string, pinId: string },
};

const initialState = {
  chatheads: [],
  open: null,
  feedback: null,
};

const conversations = (state: State = initialState, action: Action): State => {
  if (action.type === 'CONVERSATION_SHOW') {
    const { payload } = action;
    if (state.chatheads.includes(payload.id)) {
      return state;
    }

    const chatheads = [...state.chatheads, payload.id];
    return {
      ...state,
      chatheads,
    };
  } else if (action.type === 'CONVERSATION_HIDE') {
    const { chatheads } = state;
    const { payload } = action;
    return {
      ...state,
      chatheads: chatheads.filter((id) => id !== payload.id),
    };
  } else if (action.type === 'CONVERSATION_OPEN') {
    return {
      ...state,
      open: action.payload.id,
    };
  } else if (action.type === 'CONVERSATION_CLOSE') {
    return {
      ...state,
      // if there's a feedback chathead displayed, open its flyout
      open: state.feedback ? 'feedback' : null,
    };
  } else if (action.type === 'FEEDBACK_WINDOW_OPEN') {
    const { userId, pinId } = action.payload;
    return {
      ...state,
      open: 'feedback', // open the feedback window
      feedback: { userId, pinId },
    };
  } else if (action.type === 'FEEDBACK_WINDOW_CLOSE') {
    return {
      ...state,
      open: state.open === 'feedback' ? null : state.open, // close the feedback window if it's open
      feedback: null,
    };
  } else if (action.type === 'FEEDBACK_WINDOW_SUBMIT') {
    const { payload } = action;
    const chatheads = [
      ...state.chatheads.filter((id) => id !== payload.conversationId),
      payload.conversationId,
    ];
    return {
      ...state,
      chatheads,
      open: null,
      feedback: null,
    };
  }
  return state;
};

export default conversations;
